import axios from "axios";

// const API = axios.create({ baseURL: 'http://localhost:5000'})
const API = axios.create({ baseURL: process.env.REACT_APP_API });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }

  return req;
});
// Global response interceptor: if server marks user inactive (401), force client logout
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "";
    if (status === 401) {
      // Clear local storage and redirect to login so user is effectively logged out.
      try {
        localStorage.removeItem("profile");
        localStorage.removeItem("profileDetail");
        localStorage.removeItem("currentDeviceId");
        localStorage.removeItem("pendingDeviceId");
      } catch (e) {
        // ignore
      }
      // If server provided a message about inactivity, show application's snackbar if available
      if (message && typeof window?.showSnackbar === "function") {
        try {
          window.showSnackbar(message);
        } catch (e) {
          // fallback to console
          console.warn("showSnackbar failed", e);
        }
      }
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice = (id) => API.get(`/invoices/${id}`);
export const fetchInvoiceByOrderNo = (orderNo) =>
  API.get(`/invoices/orderNo/${orderNo}`);
export const addInvoice = (invoice) => API.post("/invoices", invoice);
export const updateInvoice = (id, updatedInvoice) =>
  API.post(`/invoices/${id}`, updatedInvoice);
export const deleteInvoice = async (id) => {
  try {
    const response = await API.post(`/invoices/delete/${id}`);
    if (response.status === 200) {
      console.log(`Invoice ${id} deleted successfully!`);
      // You can perform further actions based on the success response here
    } else {
      console.log(`Failed to delete invoice ${id}. Status: ${response.status}`);
      // Handle other status codes or errors accordingly
    }
  } catch (error) {
    console.error("Error deleting invoice:", error);
    // Handle any caught errors here
  }
};
export const fetchInvoicesByUser = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
}) => API.post(`/invoices/user`, { page, rowsPerPage, id, startDate, endDate });
export const fetchInvoicesByClient = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
  creator,
}) =>
  API.post(`/invoices/client`, { page, rowsPerPage, id, startDate, endDate, creator });
export const fetchInvoicesBySupplier = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
  creator,
}) =>
  API.post(`/invoices/supplier`, {
    page,
    rowsPerPage,
    id,
    startDate,
    endDate,
    creator,
  });
export const fetchInvoicesByDealer = ({page, rowsPerPage, dealerId, startDate, endDate, partyId, supplierId }) =>
  API.post(`/invoices/dealer`, {page, rowsPerPage, dealerId, startDate, endDate, partyId, supplierId});

export const fetchInvoices = () => API.get("/invoices");
export const fetchInvoicesStats = ({ id }) =>
  API.post("/invoices/stats", { id });
export const fetchInvoicesByPage = ({
  page,
  rowsPerPage,
  startDate,
  endDate,
}) => API.post("/invoices/page", { page, rowsPerPage, startDate, endDate });

export const fetchMeeting = (id) => API.get(`/meetings/${id}`);
export const addMeeting = (meeting) => API.post("/meetings", meeting);
export const updateMeeting = (id, updatedMeeting) =>
  API.post(`/meetings/${id}`, updatedMeeting);
export const deleteMeeting = (id) => API.post(`/meetings/delete/${id}`);
export const fetchMeetingsByUser = ({
  page,
  rowsPerPage,
  userId,
  query,
  flag,
  formattedStartDate,
  endDate,
}) =>
  API.post(`/meetings/user`, {
    page,
    rowsPerPage,
    userId,
    query,
    flag,
    formattedStartDate,
    endDate,
  });
export const fetchMeetings = () => API.get("/meetings");
export const fetchMeetingsStats = ({ id }) =>
  API.post("/meetings/stats", { id });
export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient = (client) => API.post("/clients", client);
export const updateClient = (id, updatedClient) =>
  API.post(`/clients/${id}`, updatedClient);
export const deleteClient = (id) => API.post(`/clients/delete/${id}`);
export const fetchClientsByUser = (searchQuery) =>
  API.get(`/clients/user?searchQuery=${searchQuery.search}`);
export const fetchAllClients = () => API.get("/clients");
export const fetchClientsSearch = ({ query, page, limit }) =>
  API.get(
    `/clients/search?query=${encodeURIComponent(query || "")}&page=${page || 0}&limit=${
      limit || 20
    }`
  );
export const fetchClientsPage = ({ query, page, limit }) =>
  API.get(
    `/clients/page?query=${encodeURIComponent(query || "")}&page=${page || 0}&limit=${
      limit || 20
    }`
  );

export const fetchSupplier = (id) => API.get(`/suppliers/${id}`);
export const fetchSuppliers = (page) => API.get(`/suppliers?page=${page}`);
export const addSupplier = (client) => API.post("/suppliers", client);
export const updateSupplier = (id, updatedSupplier) =>
  API.post(`/suppliers/${id}`, updatedSupplier);
export const deleteSupplier = (id) => API.post(`/suppliers/delete/${id}`);
export const fetchSuppliersByUser = (searchQuery) =>
  API.get(`/suppliers/user?searchQuery=${searchQuery.search}`);
export const fetchAllSuppliers = () => API.get("/suppliers");

// export const adminSignIn =(formData)=> API.post('/users/adminSignin', formData)
export const adminSignUp = (formData) =>
  API.post("/users/adminSignup", formData);
export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgot = (formData) => API.post("/users/forgot", formData);
export const reset = (formData) => API.post("/users/reset", formData);
export const fetchUsers = ({ includeClients = false } = {}) =>
  API.get(`/users${includeClients ? "?includeClients=true" : ""}`);
export const fetchMe = () => API.get("/users/me");
export const logoutUser = (payload) => API.post("/users/logout", payload || {});
export const deleteUser = (id) => API.post(`/users/delete/${id}`);
export const updateUser = (id, updatedUser) =>
  API.post(`/users/${id}`, updatedUser);
export const changePassword = (id, newPassword) =>
  API.post(`/users/changePassword/${id}`, { newPassword });
export const updateAdminDeviceId = (id, updatedUser) =>
  API.post(`/users/deviceId/${id}`, updatedUser);
export const removeAdminDeviceId = (id, deviceId) =>
  API.post(`/users/deviceId/remove/${id}`, { deviceId });
export const updateUserSubscription = (id, updatedUser) =>
  API.post(`/users/subscription/${id}`, updatedUser);
// export const updateAdminDeviceId = ( updatedUser) =>
//   API.post(`/users/deviceId`, updatedUser);
export const fetchProfilesBySearch = (searchQuery) =>
  API.get(
    `/profiles/search?searchQuery=${
      searchQuery.search || searchQuery.year || "none"
    }`
  );
export const fetchProfile = (id) => API.get(`/profiles/${id}`);
export const fetchProfiles = () => API.get("/profiles");
export const fetchProfilesByUser = (searchQuery) =>
  API.get(`/profiles?searchQuery=${searchQuery.search}`);
// console.log("fetchProfilesByUser called in client")
// console.log(searchQuery.search)

export const createProfile = (newProfile) => API.post("/profiles", newProfile);
export const updateProfile = (id, updatedProfile) =>
  API.post(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.post(`/profiles/delete/${id}`);

export const fetchItem = (id) => API.get(`/items/${id}`);
export const fetchItems = () => API.get("/items");
export const addItem = (item) => API.post("/items", item);
export const updateItem = (id, updatedItem) =>
  API.post(`/items/${id}`, updatedItem);
export const deleteItem = (id) => API.post(`/items/delete/${id}`);
export const fetchItemsByUser = (searchQuery) =>
  API.get(`/items/user?searchQuery=${searchQuery.search}`);
